export default __webpack_public_path__ + "static/22-41e9a682807fa114298579e676564be1.jpg";